/**
 * @generated SignedSource<<ade33b254ede1f5ba6966d23daaed41b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EntityKind = "ORGANIZATION" | "USER";
import { DateTime } from "@/common/relayCustomScalar";
import { Url } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type EntityHelmetFragment$data = {
  readonly bio: string | null | undefined;
  readonly comments?: {
    readonly nodes: ReadonlyArray<{
      readonly content: string;
      readonly createdAt: DateTime;
      readonly votes: number;
    }>;
  };
  readonly createdAt: DateTime;
  readonly displayName: string;
  readonly github: string | null | undefined;
  readonly googleScholar: string | null | undefined;
  readonly id: string;
  readonly image: Url | null | undefined;
  readonly imageThumbnail: Url | null | undefined;
  readonly jobTitle?: string | null | undefined;
  readonly kind: EntityKind;
  readonly linkedin: string | null | undefined;
  readonly location: string | null | undefined;
  readonly orcid?: string | null | undefined;
  readonly username: string;
  readonly website: string | null | undefined;
  readonly " $fragmentType": "EntityHelmetFragment";
};
export type EntityHelmetFragment$key = {
  readonly " $data"?: EntityHelmetFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EntityHelmetFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EntityHelmetFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkedin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "github",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleScholar",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "website",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    },
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageThumbnail",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "orcid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "last",
              "value": 10
            }
          ],
          "concreteType": "CommentConnection",
          "kind": "LinkedField",
          "name": "comments",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Comment",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "content",
                  "storageKey": null
                },
                (v0/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "votes",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "comments(last:10)"
        }
      ],
      "type": "User",
      "abstractKey": null
    }
  ],
  "type": "Entity",
  "abstractKey": "__isEntity"
};
})();

(node as any).hash = "1b207ceefa993880de1484c7784209d4";

export default node;
